// -
import React from "react";
import * as subjektFormatter from "./../utils/subjektFormatter";

/**
 * Render subjektu.
 */
export default class SubjektRowDetail extends React.Component {
    static propTypes = {
        subjekt: React.PropTypes.object.isRequired,  // subjekt
        bezAdresy: React.PropTypes.bool, // u subjektu se nezobrazí řádek s adresou
    };

    static defaultProps = {
        bezAdresy: false
    };

    render() {
        const {subjekt, bezAdresy} = this.props;

        return <div>
            <div className="subjekt-name">{subjektFormatter.getUplnyNazev(subjekt)}</div>
            {!bezAdresy && subjekt.adresaTrv && <div>
                <small>{subjekt.adresaTrv.popis}</small>
            </div>}
        </div>
    }
}
